module.exports = {"title":"Meine Daten","deleteAccountButton":"Meinen Account löschen","meta":"Account"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/account.json
// module id = SITO
// module chunks = 1